export const COMMUNITY_MEMBERSHIP_POLICY_MAX_CHARS = 4000;

export const DEFAULT_COMMUNITY_SELLER_OF_RECORD_POLICY =
  'This community membership is sold by the community host, not by LOAMIFY. Payments are processed through Stripe Connect on the host account. For billing support, refunds, and cancellations, contact the community host.';

export type CommunityMembershipPolicyInput = {
  refundPolicyText?: string | null;
  cancellationPolicyText?: string | null;
  sellerOfRecordPolicyText?: string | null;
  legacyPolicyText?: string | null;
};

export type ResolvedCommunityMembershipPolicies = {
  refundPolicyText: string | null;
  cancellationPolicyText: string | null;
  sellerOfRecordPolicyText: string | null;
  sellerOfRecordDisplayText: string;
};

export function normalizeCommunityMembershipPolicyText(text?: string | null): string | null {
  const trimmed = text?.trim();
  if (!trimmed) return null;
  return trimmed.slice(0, COMMUNITY_MEMBERSHIP_POLICY_MAX_CHARS);
}

export function resolveCommunityMembershipPolicies(
  input: CommunityMembershipPolicyInput,
): ResolvedCommunityMembershipPolicies {
  const refundPolicyText = normalizeCommunityMembershipPolicyText(input.refundPolicyText);
  const cancellationPolicyText =
    normalizeCommunityMembershipPolicyText(input.cancellationPolicyText) ??
    normalizeCommunityMembershipPolicyText(input.legacyPolicyText);
  const sellerOfRecordPolicyText = normalizeCommunityMembershipPolicyText(input.sellerOfRecordPolicyText);

  return {
    refundPolicyText,
    cancellationPolicyText,
    sellerOfRecordPolicyText,
    sellerOfRecordDisplayText: sellerOfRecordPolicyText ?? DEFAULT_COMMUNITY_SELLER_OF_RECORD_POLICY,
  };
}

export function composeCommunityMembershipCheckoutPolicyText(
  policies: ResolvedCommunityMembershipPolicies,
): string | null {
  const sections: string[] = [];

  sections.push(`Seller of record\n${policies.sellerOfRecordDisplayText}`);

  if (policies.refundPolicyText) {
    sections.push(`Refund policy\n${policies.refundPolicyText}`);
  }

  if (policies.cancellationPolicyText) {
    sections.push(`Cancellation policy\n${policies.cancellationPolicyText}`);
  }

  return sections.join('\n\n');
}

export function communityMembershipPoliciesRequireCheckoutConsent(isPaidCommunity: boolean): boolean {
  return isPaidCommunity;
}

export function communityMembershipPoliciesHaveCreatorCopy(
  policies: ResolvedCommunityMembershipPolicies,
): boolean {
  return Boolean(
    policies.refundPolicyText || policies.cancellationPolicyText || policies.sellerOfRecordPolicyText,
  );
}
